import {
  DetailsTab as DetailsTabBase,
  DETAILS_TAB_VARIANT,
} from 'components/BuildingDetailTabs/BuildingDetailsTab';

export const DetailsTab = (props) => (
  <DetailsTabBase {...props} variant={DETAILS_TAB_VARIANT.PROPERTY_PORTAL} />
);
